import React, { useState } from 'react';
import {
    Box,
    Button,
    TextField
} from '@material-ui/core';
import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import UcIndicatorDialog from './UcIndicatorDialog';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1)
    },
    inputWrapper: {
        display: 'flex',
        gap: 0,
        alignItems: 'stretch',
        '& .MuiTextField-root': {
            flex: 1
        }
    },
    textField: {
        '& .MuiOutlinedInput-root': {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            '& fieldset': {
                borderRight: 'none'
            }
        }
    },
    addButton: {
        minWidth: 120,
        height: 56,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        borderLeft: 'none',
        backgroundColor: '#ff9800',
        color: '#fff',
        fontWeight: 600,
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: '#e68900',
            boxShadow: 'none'
        }
    },
    clearButton: {
        height: 56,
        minWidth: 48,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        color: theme.palette.error.main,
        borderLeft: `1px solid ${theme.palette.divider}`,
        '&:hover': {
            backgroundColor: theme.palette.error.light,
            color: '#fff'
        }
    }
}));

const formatValue = (skillDimensionRef) => {
    if (!skillDimensionRef) return '';
    return skillDimensionRef.name || '';
};

const UcIndicatorPicker = ({ value, onChange, label = 'Unit of Competence Indicator' }) => {
    const classes = useStyles();
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleConfirm = (skillDimensionRef) => {
        onChange(skillDimensionRef);
        setDialogOpen(false);
    };

    const handleClear = () => {
        onChange(null);
    };

    return (
        <Box className={classes.container}>
            <Box className={classes.inputWrapper}>
                <TextField
                    label={label}
                    value={formatValue(value)}
                    variant="outlined"
                    placeholder="No indicator selected"
                    inputProps={{ readOnly: true }}
                    className={classes.textField}
                />
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => setDialogOpen(true)}
                    className={classes.addButton}
                >
                    Add
                </Button>
                {value && (
                    <Button
                        onClick={handleClear}
                        className={classes.clearButton}
                        title="Remove indicator"
                    >
                        <DeleteIcon />
                    </Button>
                )}
            </Box>

            <UcIndicatorDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                onConfirm={handleConfirm}
            />
        </Box>
    );
};

export default UcIndicatorPicker;
